import Cookies from 'js-cookie';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initialize);
} else {
	initialize();
}

/*
* Script to handle the playbook.
*/

let starred = Cookies.get('_actions_starred');
let checked = Cookies.get('_actions_checked');
starred = starred ? JSON.parse(starred) : [];
checked = checked ? JSON.parse(checked) : [];

const overlay = document.querySelector('.playbook__overlay');

function initialize () {
	/*
	* Document has loaded.
	*/
    if (!overlay) {
        return;
    }

    const triggers = document.querySelectorAll('[data-playbook-action-trigger]');
    triggers.forEach((trigger, i) => {
        trigger.addEventListener('click', toggleAction);
    });

    const resultOverlayOpenTriggers = document.querySelectorAll('[data-playbook-result-overlay-open]');
    const resultOverlayClose = document.querySelector('[data-playbook-result-overlay-close]');

    resultOverlayOpenTriggers.forEach((trigger) => {
        trigger.addEventListener('click', openResultOverlay);
    });
    resultOverlayClose.addEventListener('click', closeResultOverlay);

    const backTrigger = document.querySelector('.playbook__overlay-navigation-back');
    const nextTriggers = document.querySelectorAll('.playbook__overlay-navigation-next');
    backTrigger.addEventListener('click', navigateBack);
    nextTriggers.forEach((trigger) => {
        trigger.addEventListener('click', navigateNext);
    });

    const pdfLinks = document.querySelectorAll('.playbook__pdf-link');
    pdfLinks.forEach((link) => {
        link.addEventListener('click', downloadPDF);
    });
}

function downloadPDF(e) {
    e.preventDefault();

    console.log('event: Playbook - Lastet ned PDF');
    const pdfLink = e.currentTarget.href;
    // console.log({pdfLink});
    window.plausible("Playbook - Lastet ned PDF", {
        callback: function () {
            console.log('Plausible callback');
            location.href = pdfLink;
        }
    });
}

function navigateBack(e) {
    const current = document.querySelector('.playbook__overlay-screen.active');
    const currentStep = current.dataset.screen;

    if (parseInt(currentStep) > 0) {
        const previous = document.querySelector('.playbook__overlay-screen[data-screen="' + (parseInt(currentStep) - 1) + '"]');
        if (previous) {
            current.classList.remove('active');
            previous.classList.add('active');
        }

        if (previous.dataset.style === 'dark') {
            overlay.classList.add('dark');
        } else {
            overlay.classList.remove('dark');
        }

        // Hide navigation on first step.
        if (parseInt(currentStep) === 1) {
            const navigation = document.querySelector('.playbook__overlay-navigation');
            navigation.classList.add('hidden');
        }

        // Show next button on not last step.
        const nextButton = document.querySelector('.playbook__overlay-navigation .playbook__overlay-navigation-next');
        nextButton.classList.remove('hidden');
    }
}
function navigateNext(e) {
    const total = document.querySelectorAll('.playbook__overlay-screen').length;
    const current = document.querySelector('.playbook__overlay-screen.active');
    const currentStep = current.dataset.screen;

    if (parseInt(currentStep) < total) {
        const next = document.querySelector('.playbook__overlay-screen[data-screen="' + (parseInt(currentStep) + 1) + '"]');
        if (next) {
            current.classList.remove('active');
            next.classList.add('active');

            // Set the correct action button states.
            const actions = next.querySelectorAll('.playbook__action-button');
            actions.forEach((action) => {
                action.classList.remove('active'); // Remove all active states.
                if (action.dataset.actionButtonType === 'star' && starred.includes(action.dataset.actionId)) {
                    action.classList.add('active');
                }
                if (action.dataset.actionButtonType === 'check' && checked.includes(action.dataset.actionId)) {
                    action.classList.add('active');
                }
            });

            // Make sure the navigation is visible.
            const navigation = document.querySelector('.playbook__overlay-navigation.hidden');
            if (navigation) {
                navigation.classList.remove('hidden');
            }

            // Set the correct screen style.
            if (next.dataset.style === 'dark') {
                overlay.classList.add('dark');
            } else {
                overlay.classList.remove('dark');
            }

            // Hide next button on last step.
            if (parseInt(currentStep) + 1 === (total - 1)) {
                const nextButton = document.querySelector('.playbook__overlay-navigation .playbook__overlay-navigation-next');
                nextButton.classList.add('hidden');
            }
        }
    }
}

function openResultOverlay(e) {
    const resultOverlay = document.querySelector('.playbook__overlay');
    const firstScreen = resultOverlay.querySelector('.playbook__overlay-screen[data-screen="0"]');
    const numberOfCheckedElement = document.querySelector('.playbook__overlay-checked-number');

    const totalActions = document.querySelectorAll('.playbook__action-counter').length;

    // Total number of checked elements.
    const totalChecked = checked.length + starred.length;
    // Set the number of checked elements to the overlay text.
    numberOfCheckedElement.innerHTML = totalChecked;

    const totalPercentageChecked = totalChecked / totalActions * 100;

    // Reset the percentage level-specific texts.
    const levelTexts = document.querySelectorAll('.level.active');
    levelTexts.forEach((levelText) => {
        levelText.classList.remove('active');
    });

    // Set the correct feedback text.
    let levelText = null;
    if (totalPercentageChecked < 1) {
        levelText = firstScreen.querySelector('.level-one');
    } else if (totalPercentageChecked < 40) {
        levelText = firstScreen.querySelector('.level-two');
    } else if (totalPercentageChecked < 80) {
        levelText = firstScreen.querySelector('.level-three');
    } else {
        // up to 100
        levelText = firstScreen.querySelector('.level-four');
    }
    levelText.classList.add('active');

    // Set the correct feedback text on the "next up"-steps.
    const nextUpScreens = resultOverlay.querySelectorAll('[data-next-up-step-id]');

    nextUpScreens.forEach((nextUpScreen) => {
        const stepId = nextUpScreen.dataset.nextUpStepId;

        const actionsInStepElements = resultOverlay.querySelectorAll(`[data-step-id="${stepId}"]`);
        const actionsInStep = Array.from(actionsInStepElements);
        const stepTotalActions = actionsInStep.length;
        const stepCheckedActions = actionsInStep.filter((action) => starred.includes(action.dataset.stepActionId) || checked.includes(action.dataset.stepActionId)).length;

        const stepPercentageChecked = stepTotalActions.length === 0 ? 0 : stepCheckedActions / stepTotalActions * 100;

        console.log({stepId, stepTotalActions, stepCheckedActions, stepPercentageChecked});

        let levelText = null;
        if (stepPercentageChecked < 1) {
            levelText = nextUpScreen.querySelector('.level-one');
        } else if (stepPercentageChecked < 40) {
            levelText = nextUpScreen.querySelector('.level-two');
        } else if (stepPercentageChecked < 80) {
            levelText = nextUpScreen.querySelector('.level-three');
        } else {
            // up to 100
            levelText = nextUpScreen.querySelector('.level-four');
        }
        levelText.classList.add('active');
    });

    // Open the overlay.
    resultOverlay.classList.add('open');

    // Request fullscreen.
    if (resultOverlay.requestFullscreen) {
        resultOverlay.requestFullscreen();
    } else if (resultOverlay.webkitRequestFullscreen) { /* Safari */
        resultOverlay.webkitRequestFullscreen();
    } else if (resultOverlay.msRequestFullscreen) { /* IE11 */
        resultOverlay.msRequestFullscreen();
    }

    console.log('event: Playbook - fullskjermvisning');
    window.plausible("Playbook - fullskjermvisning");
}
function closeResultOverlay(e) {
    const resultOverlay = document.querySelector('.playbook__overlay');

    resultOverlay.classList.remove('open');

    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
    }
}

function toggleAction(e) {
    const elem = e.target.closest('[data-playbook-action-trigger]');

    let selectedGroup = elem.dataset.actionButtonType === 'star' ? starred : checked;
    let otherGroup = elem.dataset.actionButtonType === 'star' ? checked : starred;
    let otherButtonType = elem.dataset.actionButtonType === 'star' ? 'check' : 'star';

    if (selectedGroup.includes(elem.dataset.actionId)) {
        elem.classList.remove('active');

        const i = selectedGroup.indexOf(elem.dataset.actionId);
        selectedGroup.splice(i, 1);
        // selectedGroup = selectedGroup.filter((item) => item !== elem.dataset.actionId);
    } else {
        elem.classList.add('active');

        selectedGroup.push(elem.dataset.actionId);

        // Remove from other group if it is checked.
        if (otherGroup.includes(elem.dataset.actionId)) {
            const i = otherGroup.indexOf(elem.dataset.actionId);
            otherGroup.splice(i, 1);
            const otherButton = document.querySelector(`[data-action-id="${elem.dataset.actionId}"][data-action-button-type="${otherButtonType}"]`);
            if (otherButton) {
                otherButton.classList.remove('active');
            }
        }
    }

    const starredCount = document.querySelector('.playbook__point-selected-star-indicator');
    const checkedCount = document.querySelector('.playbook__point-selected-checkmark-indicator');
    starredCount.innerHTML = starred.length;
    checkedCount.innerHTML = checked.length;

    Cookies.set('_actions_starred', JSON.stringify(starred), { expires: 365 });
    Cookies.set('_actions_checked', JSON.stringify(checked), { expires: 365 });
}